(function () {
  var popup = document.querySelector('[data-saint-avs-membership-popup]');

  if (!popup) {
    return;
  }

  var dayInMilliseconds = 24 * 60 * 60 * 1000;
  var popupMode = popup.getAttribute('data-popup-mode') || 'main';
  var storageKey = popup.getAttribute('data-storage-key') || '';
  var mainPopupStorageKey = 'saintAvsMembershipPopupClosedAt';
  var mainPopupCooldown = 600000;
  var dialog = popup.querySelector('.saint-avs-membership-popup__dialog');
  var closeControls = popup.querySelectorAll('[data-saint-avs-popup-close]');
  var popupLinks = popup.querySelectorAll('a');
  var closeButton = popup.querySelector('.saint-avs-membership-popup__close');
  var previousFocus = null;
  var focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function canUseStorage() {
    try {
      var testKey = 'saintAvsMembershipPopupStorageTest';
      window.localStorage.setItem(testKey, testKey);
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function getLastSeen() {
    if (!storageKey || !canUseStorage()) {
      return 0;
    }

    return Number(window.localStorage.getItem(storageKey)) || 0;
  }

  function rememberPopupClosed() {
    if (!canUseStorage()) {
      return;
    }

    if (popupMode === 'upgrade' && storageKey) {
      window.localStorage.setItem(storageKey, String(Date.now()));
    }

    if (popupMode === 'main') {
      window.localStorage.setItem(mainPopupStorageKey, String(Date.now()));
    }
  }

  function shouldShow() {
    if (popupMode === 'main') {
      if (!canUseStorage()) {
        return true;
      }

      return Date.now() - (Number(window.localStorage.getItem(mainPopupStorageKey)) || 0) > mainPopupCooldown;
    }

    return Date.now() - getLastSeen() > dayInMilliseconds;
  }

  function openPopup() {
    previousFocus = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('saint-avs-membership-popup-is-open');

    window.requestAnimationFrame(function () {
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      } else if (dialog) {
        dialog.focus({ preventScroll: true });
      }
    });
  }

  function closePopup() {
    rememberPopupClosed();
    popup.hidden = true;
    document.documentElement.classList.remove('saint-avs-membership-popup-is-open');

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
  }

  closeControls.forEach(function (control) {
    control.addEventListener('click', closePopup);
  });

  popupLinks.forEach(function (link) {
    link.addEventListener('click', rememberPopupClosed);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !popup.hidden) {
      closePopup();
    }

    if (event.key !== 'Tab' || popup.hidden || !dialog) {
      return;
    }

    var focusableElements = Array.prototype.slice.call(dialog.querySelectorAll(focusableSelector));
    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!firstFocusable || !lastFocusable) {
      return;
    }

    if (event.shiftKey && document.activeElement === firstFocusable) {
      event.preventDefault();
      lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  });

  if (shouldShow()) {
    window.setTimeout(openPopup, popupMode === 'upgrade' ? 900 : 650);
  }
})();
